module.exports = __webpack_public_path__ + "img/404.410ceac0.png";